import { useCallback, useRef, useState } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';

import Navigation from '../navigation/Navigation';

import { sendReferrals } from '../../utils/api';

import './Referrals.css';

function Referrals({ handleError, handleFeedback }) {
  const textareaRef = useRef(null);

  const [isSending, setIsSending] = useState(false);

  const handleSubmit = useCallback(async () => {
    const value = textareaRef.current.value;

    if (value) {
      const emails = [...new Set(value.split('\n'))].filter(email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
      
      if (emails.length) {
        setIsSending(true);

        try {
          const response = await sendReferrals(emails);

          if (response !== null) {
            
          }
        } catch (e) {
          handleError(e);
        }

        setIsSending(false);
      }
    }
  }, [handleError]);

  return (
    <div id="content">
      <div id="referrals">
        <div className="instructions">Enter email addresses (one on each line) to send your referral link.</div>
        <textarea ref={textareaRef} placeholder={!!isSending ? 'Give me a sec...' : 'Enter email addresses'} disabled={!!isSending}></textarea>
        <div className="actions">
          <div className="action action-primary" onClick={handleSubmit}>Send Referrals</div>
        </div>
      </div>
      <Navigation handleFeedback={handleFeedback} />
    </div>
  );
}

export default withAuthenticationRequired(Referrals);